import { useState, useEffect, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Api from '../../../../component/Api';

const parseYearFromHash = (hash) => {
    const content = hash.startsWith('#') ? hash.slice(1) : hash;
    for (const part of content.split('/')) {
        if (part.startsWith('year=')) {
            return decodeURIComponent(part.slice(5));
        }
    }
    return '';
};

export const useAdmissionYear = () => {
    const { http } = useMemo(() => Api(), []);
    const location = useLocation();

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [admissionYear, setAdmissionYear] = useState(() => parseYearFromHash(location.hash));

    useEffect(() => {
        let cancelled = false;
        setLoading(true);

        http.get('/is/admissionYearFilter')
            .then(res => {
                if (cancelled) return;

                const raw = Array.isArray(res.data) ? res.data
                    : Array.isArray(res.data?.data) ? res.data.data
                        : [];

                const mapped = raw.map(item => ({
                    value: String(item.year ?? item.admission_year ?? item.value ?? item),
                    label: String(item.year ?? item.admission_year ?? item.label ?? item),
                }));

                setOptions(mapped);
            })
            .catch(err => console.error('[useAdmissionYear] fetch error:', err))
            .finally(() => { if (!cancelled) setLoading(false); });

        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAdmissionYearChange = useCallback((year) => {
        setAdmissionYear(year ?? '');
    }, []);

    const selectedOption = options.find(o => String(o.value) === String(admissionYear)) || null;

    return {
        admissionYear,
        options,
        loading,
        selectedOption,
        handleAdmissionYearChange,
    };
};